import { motion } from "framer-motion";
import { HomeLayout } from "layouts";
import { useEffect, useState, useRef } from "react";
import { gql } from "graphql-request";
import {
  fetcher,
  imageUrl,
  mergeByProperty,
  extractCocktails,
  uniqObjArrayOld as uniqObjArray,
  gqlClient,
} from "utils";
import { useRouter } from "next/router";
import { useDebounce, useQuery, useSession, useInApp } from "hooks";
import Image from "next/legacy/image";
import Link from "next/link";
import Head from "next/head";
import { cocktailFragmentWithOutMeta as cocktailFragment } from "queries/fragments";
import uniqBy from "lodash/uniqBy";
import sortBy from "lodash/sortBy";
import {
  Modal,
  Loader,
  CreateListModal,
  CreateReviewModal,
  Section,
  Container,
  FileButton,
  Button,
  ButtonLink,
  Input,
  Icon,
  Stars,
} from "components";
import { Cocktail as CocktailComponent } from "components";
import { cocktailTransformer } from "queries/transformers";
import * as cx from "classnames/bind";
import s from "styles/Scanner.module.scss";
import g from "styles/Gallery.module.scss";
import r from "styles/reviewStars.module.scss";
import store from "store2";

import { push } from "@socialgouv/matomo-next";
import urlSlug from "url-slug";

import OutsideClickHandler from "react-outside-click-handler";

import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Cookies from "js-cookie";

import {
  useHits,
  useSearchBox,
  Configure,
  InstantSearch,
} from "react-instantsearch";

import algoliasearch from "algoliasearch";

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY,
);

const indexName = "cocktailclub-products-en";

const algoliaIndex = searchClient.initIndex("cocktailclub-cocktails-en");

const SearchBox = ({
  productsSearchRef,
  searchString,
  setSearchString,
  debouncedSearchString,
  ...props
}) => {
  const { query, refine } = useSearchBox(props);
  const { t } = useTranslation();
  const {
    hits,
    results: { nbHits },
  } = useHits(props);

  useEffect(() => {
    if (debouncedSearchString) {
      props.setAllResultsUrl("/products?s=" + debouncedSearchString);
    } else {
      props.setAllResultsUrl("/products");
    }
    if (debouncedSearchString != query && debouncedSearchString.length > 2) {
      refine(debouncedSearchString);
    } else if (debouncedSearchString.length < 3) {
      props.setResults([]);
      props.setTotal([]);
    }
  }, [debouncedSearchString]);

  useEffect(() => {
    if (debouncedSearchString != "") {
      const results = hits.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.objectID === value.objectID),
      );
      props.setResults(debouncedSearchString.length < 3 ? [] : results);
      props.setTotal(debouncedSearchString.length < 3 ? [] : nbHits);
    }
  }, [hits, nbHits, debouncedSearchString, refine]);

  const ref = useRef(null);

  const emptyString = () => {
    setSearchString("");
    ref.current.focus();
  };

  return (
    <div>
      <form action={`/products`} method="get">
        <input
          type="text"
          name="s"
          placeholder={t("Search...")}
          onChange={(e) => {
            setSearchString(e.target.value);
          }}
          ref={ref}
          value={searchString}
          onFocus={() => {
            if (productsSearchRef && productsSearchRef.current) {
              productsSearchRef.current.focus();
            } else {
              props.setClosedSearch(false);
            }
          }}
        />
        <div onClick={emptyString} className={cx(s.clearBtn)}>
          <Icon size="far" svg="times" />
        </div>
        <button type="submit">
          <Icon size="far" svg="search" />
        </button>
      </form>
    </div>
  );
};
const SearchHolder = (props) => {
  const [total, setTotal] = useState([]);
  const [results, setResults] = useState([]);
  const [allResultsUrl, setAllResultsUrl] = useState("/products");

  const [searchString, setSearchString] = useState("");
  const [debouncedSearchString, setDebouncedValue] = useDebounce(searchString);

  return (
    <>
      <InstantSearch searchClient={searchClient} indexName={indexName}>
        <Configure length="24" offset="0" />
        <div className={cx("searchHolder", s.searchHolder)}>
          <SearchBox
            {...props}
            searchString={searchString}
            setSearchString={setSearchString}
            debouncedSearchString={debouncedSearchString}
            setResults={setResults}
            setTotal={setTotal}
            setAllResultsUrl={setAllResultsUrl}
          />
          <div
            className={cx(
              "searchResults",
              s.searchResults,
              results.length > 0 && !props.closed ? s.open : "",
            )}
          >
            {results.length > 0 && (
              <div className="mt8">
                <p className="Bold">
                  <small>
                    {results.length > 0 && <>Found {total} results. </>}
                    <Link href={allResultsUrl}>View all</Link>
                  </small>
                </p>
              </div>
            )}
            <div className="flex row Scroll modalScroll">
              {results.map((result) => {
                return (
                  <Link
                    key={result.image_id}
                    href={`/products/${urlSlug(result.name)}`}
                    className={cx(
                      s.productItem,
                      "rowItem rowItemScroll__S text-center",
                    )}
                    onClick={() => {
                      props.setClosedSearch(true);
                      setSearchString("");
                      setDebouncedValue("");
                    }}
                  >
                    <div
                      className={cx(s.productItemImage)}
                      alt={result.name}
                      title={result.name}
                      style={{
                        backgroundImage: `url( ${imageUrl(result.image_id)})`,
                      }}
                    />
                    <div className="Heading__small">{result.name}</div>
                  </Link>
                );
              })}
            </div>
            {/*
          {results.length > 0 && (
            <ButtonLink
              onClick={() => {
                props.setClosedSearch(true);
              }}
              href={allResultsUrl}
              className="Primary Full"
            >
              See all results
            </ButtonLink>
          )}
        */}
          </div>
        </div>
      </InstantSearch>
    </>
  );
};

const Product = ({ product, slug, ...props }) => {
  const router = useRouter();
  const [scanned, setScanned] = useState(false);

  useEffect(() => {
    push(["trackEvent", "Products", "View product", "View product"]);
  }, []);

  const trackThumbsDown = () => {
    push(["trackEvent", "Products", "Click thumb down", "Thumb down"]);
  };

  const [promotedCocktails, setPromotedCocktails] = useState([]);
  const [cocktails, setCocktails] = useState(
    ((product || {}).cocktails || []).map((c) => ({ ...c, loading: true })),
  );
  const [isFetching, setIsFetching] = useState(false);
  const [cocktailsIsFetched, setCocktailsIsFetched] = useState(false);
  const [showCreateReviewModal, setShowCreateReviewModal] = useState(false);

  const country = (Cookies.get("__country") || "no").toLowerCase();
  const externalLink = (product?.extra_data?.external_links || {})[country];

  const isInApp = useInApp();

  useEffect(() => {
    async function fetchData() {
      const promotedIds =
        ((product || {}).extra_data || {}).relatedCocktails || [];
      const cocktails = uniqObjArray(
        extractCocktails(product.parent, (product || {}).cocktails || []).map(
          (c) => ({ ...c, loading: true }),
        ),
      );
      const cocktailIds = cocktails.map((c) => c.id);
      const queryIds = [...new Set(cocktailIds.concat(promotedIds))];
      const country = Cookies.get("__country") || "";

      const response = await algoliaIndex.search("", {
        hitsPerPage: 1000,
        facetFilters: [queryIds.map((id) => `objectID:${id}`)],
        filters: country
          ? `(exclusive_countries:${country} OR is_exclusive:false) AND NOT excluded_countries:${country}`
          : "is_exclusive:false",
      });

      /*
      const defaultQuery = gql`hidden: {_eq: false}, _and: [
            {recipes: {_not: {excluded_countries_codes: {_contains: $country}}}},
            {_or: [
                {recipes: {exclusive_countries_codes: {_contains: $country}}},
                {recipes: {exclusive_countries_codes: {_cast: {String: {_eq: "[]"}}}}}
            ]}

        ]`;
      const cocktailsQuery = gql`query productRelated($country: jsonb) @cached(ttl: 300) {
      cocktails(where: {id: {_in: [${queryIds.join(",")}]}, ${defaultQuery}}) {
                id
                name
                slug
            image {
                id
            }
                recipes {
                    id
                    name
                    default
                    timeline {
                        duration
                        video_embed_id
                        steps(order_by: {position: asc}) {
                            title
                            description
                            ingredients(order_by: {order: asc}) {
                                ingredient {
                                    id
                                    name
                                    slug
                                    type
                                    images {
                                        id
                                    }
                                    parent_id
                                }
                            }
                        }
                    }
                }
            }
  }`;
      const response = await fetcher(cocktailsQuery, { country });
        */
      setCocktails(
        response.hits
          .filter((c) => cocktailIds.includes(parseInt(c.objectID)))
          .map(cocktailTransformer),
      );
      setPromotedCocktails(
        mergeByProperty(
          promotedCocktails,
          response.hits
            .filter((c) => promotedIds.includes(parseInt(c.objectID)))
            .map((c) => ({
              ...cocktailTransformer(c),
            })),
          "id",
        ),
      );
      setCocktailsIsFetched(true);
      setIsFetching(false);
    }

    if (product && !isFetching) {
      setCocktailsIsFetched(false);
      setIsFetching(true);
      fetchData();
    }
  }, [product]);

  const { data: session, status } = useSession();

  useEffect(() => {
    setScanned(!!router.query.scanned);
  }, [router.query]);

  useEffect(() => {
    setIsFetching(false);
    setShowModal(false);
  }, [router.asPath]);

  const style = {
    display: scanned ? "block" : "none",
  };

  const { t } = useTranslation();

  const [closedSearch, setClosedSearch] = useState(false);

  const {
    data: { filters },
  } = useQuery("filters/all");

  const [showModal, setShowModal] = useState(false);
  const [nextProduct, setNextProduct] = useState();
  const [loading, setLoading] = useState(false);
  const onChange = async (formData) => {
    setLoading(true);
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_REST_API_URL}scanner/predict/v3`,
      {
        method: "POST",
        body: formData,
        credentials: "same-origin",
      },
    );
    const result = (await response.json()) || {};
    setLoading(false);
    if (result.slug) {
      router.push(`/products/${result.slug}?scanned=true`);
    }
  };

  const [showCreateListModal, setShowCreateListModal] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_REST_API_URL}scanner/results/${router.query.results}`,
      );
      const results = await response.json();
      if (results.products) {
        const nextIndex =
          results.products.findIndex((p) => p.slug === slug) + 1;
        setNextProduct(results.products[nextIndex]);
      }
    }
    if (router.query.results) {
      fetchData();
    }
  }, [router]);

  const gotoNextBottle = () => {
    if (nextProduct) {
      router.push({ ...router, pathname: `/products/${nextProduct.slug}` });
    }
  };

  const [popupOpen, setPopupOpen] = useState(false);
  const thumbsUpPopup = () => {
    setPopupOpen(!popupOpen);
    const el = document.querySelector(`#relatedCocktails`);

    setTimeout(() => {
      setPopupOpen((popupOpen) => !popupOpen);
    }, 5000);

    el?.scrollIntoView({ behavior: "smooth" });
    push(["trackEvent", "Products", "Click thumb up", "Thumb up"]);
  };

  if (!product) {
    return (
      <Container className={cx(s.Loading)}>
        <div className={cx("ScanLoad", s.ScanLoad)}>
          <div>
            <img
              alt="Cocktail Club | Scanner frame"
              src="/img/icons/scanFrame.svg"
            />
            <img
              alt="Cocktail Club | Scanner bottle"
              src="/img/icons/bottle.svg"
            />
            <span></span>
          </div>
        </div>
      </Container>
    );
  }
  const averageScore =
    Math.round(product.reviews_aggregate?.aggregate?.avg?.score * 10) / 10;

  const WindowDataLayerPush = ({ bottle, cocktails }) => {
    window.dataLayer = window.dataLayer || [];
    let items = [];
    cocktails.map((c, index) => {
      items.push({
        item_id: c.objectID,
        item_name: c.name,
        index: index,
        item_category: c.categories[0]?.name,
        item_category2: c.categories[1]?.name || "",
        item_category3: c.categories[2]?.name || "",
        item_category4: c.categories[3]?.name || "",
        item_category5: c.categories[4]?.name || "",
        item_list_id: "related_drinks",
        item_list_name: "Related Drinks",
      });
    });
    window.dataLayer.push({
      event: "view_item",
      items: [
        {
          item_id: bottle.id,
          item_name: bottle.name,
          item_brand: bottle.brand?.name,
        },
      ],
    });
    window.dataLayer.push({ event: "view_item_list", items: items });
    return <></>;
  };

  return (
    <>
      <Head>
        <title key="title">
          {product.name} - {product.parent?.name} - Cocktail Club
        </title>
        <meta key="description" name="description" content="" />
        <meta
          key="ogImage"
          property="og:image"
          content={
            product.images?.length > 0
              ? imageUrl(product.images[0])
              : "/img/bottle.jpg"
          }
        />
        <meta
          property="og:image:alt"
          content={
            product.name + " - " + product.parent?.name + " - Cocktail Club"
          }
        />
        <meta
          key="ogUrl"
          property="og:url"
          content={"https://cocktailclub.com/products/" + product.slug}
        />
        <link
          key="canonical"
          rel="canonical"
          href={"https://cocktailclub.com/products/" + product.slug}
        />

        <meta key="ogType" property="og:type" content="article" />
        <meta
          key="ogTitle"
          property="og:title"
          content={
            product.name + " - " + product.parent?.name + " - Cocktail Club"
          }
        />
        <meta key="ogDescription" property="og:description" content="" />

        <meta property="article:section" content="Spirits" />
        <meta
          property="article:tag"
          content={
            product.name + " - " + product.parent?.name + " - Cocktail Club"
          }
        />
      </Head>
      <Section className={cx(s.ScannerContent)}>
        <Container className={cx(s.Results)}>
          <h2 className="Heading" style={style}>
            {t("Is this the bottle you scanned?")}
          </h2>
          <div
            id="ScannerResult"
            className={cx("ScannerResult flex flex-wrap", s.ScannerResult)}
          >
            <div className={cx("split-item-50__d", s.ScanImg)}>
              <button
                backBtn="true"
                className={cx(
                  "backBtn backBtnStyled",
                  s.backBtn,
                  s.backBtnStyled,
                )}
                onClick={() => router.back()}
              ></button>
              <div className={cx(s.thumbsHolder)}>
                <Button
                  onClick={() => {
                    setShowModal(true);
                    trackThumbsDown();
                  }}
                  className={cx(s.thumbsDown)}
                  svg="thumbs-down"
                  size="fas"
                  style={style}
                >
                  {t("NO")}
                </Button>
                {/*
                <Button
                  onClick={() => gotoNextBottle()}
                  className={cx(s.thumbsDown, "hidden")}
                  svg="thumbs-down"
                  size="fal"
                />
                */}
                <Button
                  onClick={() => thumbsUpPopup()}
                  className={cx(s.thumbsUp)}
                  svg="thumbs-up"
                  size="fas"
                  style={style}
                  leftIcon
                >
                  {t("YES")}
                </Button>
              </div>
              <div
                className={cx(
                  "text-center success-box",
                  s.thumbsUpPopup,
                  popupOpen ? s.active : s.hidden,
                )}
              >
                {t("Great. Lets look at some cocktails!")}
              </div>
              <Image
                alt={product.name}
                src={
                  product.images.length > 0
                    ? imageUrl(product.images[0])
                    : "/img/bottle.jpg"
                }
                objectFit="contain"
                layout="responsive"
                height={900}
                width={900}
              />
            </div>
            {scanned ? (
              <FileButton
                svg="camera"
                size="far"
                className={cx(s.scanBtn)}
                accept="image/jpeg,image/png,image/jpg"
                name="scannedImage"
                onChange={onChange}
                loading={loading}
              >
                {t("Scan again")}
              </FileButton>
            ) : (
              <></>
            )}
            <div
              className={cx(
                "split-item-50__d flex-grow flex align-center",
                s.ScanInfo,
              )}
            >
              <div>
                <h2 className="Heading">{product.name}</h2>
                {product.brand && (
                  <p>
                    <span>{t("Brand")}: </span> {product.brand?.name}
                  </p>
                )}
                {product.parent?.parent ? (
                  <>
                    <p>
                      <span>{t("Category")}: </span>{" "}
                      {product.parent?.parent?.name}
                    </p>
                    <p>
                      <span>{t("Sub-category")}: </span> {product.parent?.name}
                    </p>
                  </>
                ) : (
                  product.parent && (
                    <>
                      <p>
                        <span>{t("Category")}: </span> {product.parent.name}
                      </p>
                    </>
                  )
                )}
                {/*
                  <p>
                    <span>Price avg.: </span> 600 NOK
                  </p>
                  */}
                {product.alcohol_percentage && (
                  <p>
                    <span>{t("Alcohol")}: </span> {product.alcohol_percentage}%
                  </p>
                )}
                {product.country && (
                  <p>
                    <span>{t("Country of origin")}: </span>{" "}
                    {product.country?.name}
                  </p>
                )}
                {product.description && (
                  <p>
                    <span>{product.description}</span>
                  </p>
                )}
                <p className="productReviews space-between">
                  {product.reviews.length > 0 ? (
                    <>
                      <a href="#reviews">
                        <Stars score={averageScore} className={cx(r.avgM)} />
                      </a>
                      <a href="#reviews">
                        {averageScore}&nbsp;{t("out of")}&nbsp;
                        {product.reviews.length}&nbsp;{t("reviews")}
                      </a>
                    </>
                  ) : (
                    <>
                      <span>Reviews</span>No reviews
                    </>
                  )}
                </p>

                {session?.user ? (
                  <Button
                    style={{ float: "none" }}
                    className={cx("Button Hollow mb12")}
                    onClick={() => setShowCreateReviewModal(true)}
                    svg="stars"
                    size="fal"
                  >
                    {t("Add a review")}
                  </Button>
                ) : (
                  <button
                    className={cx("Button Hollow Blue mb12")}
                    onClick={() =>
                      setLoginModalState({
                        show: true,
                        index: 0,
                        message: t(
                          "Please log in or register an account to add a review",
                        ),
                      })
                    }
                  >
                    {t("Add a review")}
                  </button>
                )}
                <br />
                {externalLink && (
                  <ButtonLink
                    style={{ float: "none" }}
                    className="Button Peach"
                    href={externalLink}
                    svg="shopping-cart"
                    size="far"
                    {...(isInApp ? {} : { target: "_blank" })}
                  >
                    {t("Purchase product")}
                  </ButtonLink>
                )}
              </div>
            </div>
          </div>
          <div id="relatedCocktails" style={{ height: "60px" }}></div>
          {promotedCocktails.length > 0 && cocktailsIsFetched ? (
            <>
              <h2 className="Heading mb24">
                {product.name} {t("specials")}
              </h2>
              <div className={cx("GalleryFeed row", g.GalleryFeed)}>
                {(promotedCocktails || []).map((cocktail) => (
                  <CocktailComponent
                    key={cocktail.id}
                    cocktail={cocktail}
                    setShowCreateListModal={setShowCreateListModal}
                    setShowLoginModal={props.setShowLoginModal}
                    initial={false}
                    layout={false}
                    prefetch={false}
                    layoutSuffix="specials"
                    {...props}
                  />
                ))}
              </div>
              <br />
              <br />
            </>
          ) : (
            <></>
          )}
          <h2 className="Heading my32">
            {t("Cocktails to make with this product")}
          </h2>
          {!cocktailsIsFetched ? (
            <Loader relative />
          ) : cocktails.length > 0 ? (
            <div className={cx("GalleryFeed row", g.GalleryFeed)}>
              {(cocktails || []).map((cocktail) => (
                <CocktailComponent
                  key={cocktail.id}
                  cocktail={cocktail}
                  setShowCreateListModal={setShowCreateListModal}
                  setShowLoginModal={props.setShowLoginModal}
                  initial={false}
                  layout={false}
                  prefetch={false}
                  {...props}
                />
              ))}
              <WindowDataLayerPush bottle={product} cocktails={cocktails} />
            </div>
          ) : (
            <>
              <p>
                {t(
                  "Unfortunately there are currently no registered cocktails to make with this product.",
                )}
              </p>
              <div className="ButtonGroup">
                <ButtonLink
                  className="Primary"
                  href="/cocktails"
                  svg="cocktail"
                  size="far"
                >
                  {t("Browse cocktails")}
                </ButtonLink>
                <ButtonLink
                  className="Primary Blue"
                  href="/products"
                  svg="wine-bottle"
                  size="far"
                >
                  {t("Browse bottles")}
                </ButtonLink>
              </div>
              <br />
            </>
          )}
        </Container>
      </Section>
      <Section
        id="reviews"
        style={{ paddingTop: "80px", backgroundColor: "#ffffff" }}
      >
        <Container>
          <h2 className="Heading">
            {t("Reviews")}&nbsp;({product.reviews.length})
          </h2>
          <div>
            <Stars score={averageScore} className={cx(r.avgL)} />
            <div className={cx(r.starCount)}>
              {averageScore}&nbsp;{t("out of")}&nbsp;{product.reviews.length}
              &nbsp;{t("reviews")}
            </div>
            <br />
            <br />
            {product.reviews.length > 0 ? (
              product.reviews.map((review, index) => {
                const name =
                  review.user.first_name || review.user.display_name || "";
                return (
                  <div className={cx(r.reviewItem)} key={index}>
                    <div className={cx(r.reviewImg)}>
                      {review.hide_name ? <>A</> : <>{name.charAt(0)}</>}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path d="M256 0C292.8 0 324.8 20.7 340.9 51.1C373.8 40.1 410.1 48.96 437 74.98C463 101 470.1 138.2 460.9 171.1C491.3 187.2 512 219.2 512 256C512 292.8 491.3 324.8 460.9 340.9C471 373.8 463 410.1 437 437C410.1 463 373.8 470.1 340.9 460.9C324.8 491.3 292.8 512 256 512C219.2 512 187.2 491.3 171.1 460.9C138.2 471 101 463 74.98 437C48.96 410.1 41 373.8 51.1 340.9C20.7 324.8 0 292.8 0 256C0 219.2 20.7 187.2 51.1 171.1C40.1 138.2 48.96 101 74.98 74.98C101 48.96 138.2 41 171.1 51.1C187.2 20.7 219.2 0 256 0V0zM352.1 224.1C362.3 215.6 362.3 200.4 352.1 191C343.6 181.7 328.4 181.7 319 191L224 286.1L184.1 247C175.6 237.7 160.4 237.7 151 247C141.7 256.4 141.7 271.6 151 280.1L207 336.1C216.4 346.3 231.6 346.3 240.1 336.1L352.1 224.1z" />
                      </svg>
                    </div>
                    <div className={cx(r.reviewContent)}>
                      <div className={cx(r.reviewUser)}>
                        {review.hide_name ? (
                          <div>
                            {t("Anonymous")}
                            <span>{t("Verified user")}</span>
                          </div>
                        ) : (
                          <div>
                            {name.split(" ")[0]}
                            <span>{t("Verified user")}</span>
                          </div>
                        )}
                      </div>
                      <Stars score={review.score} />
                      <div className={cx(r.reviewComment)}>
                        {review.comment}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>{t("No reviews yet")}</p>
            )}
          </div>
          {session?.user ? (
            <button
              className={cx("Button Primary Blue", r.addReviewBtn)}
              onClick={() => setShowCreateReviewModal(true)}
            >
              {t("Add a review")}
            </button>
          ) : (
            <button
              className={cx("Button Primary Blue", r.addReviewBtn)}
              onClick={() =>
                setLoginModalState({
                  show: true,
                  index: 0,
                  message: t(
                    "Please log in or register an account to add a review",
                  ),
                })
              }
            >
              {t("Add a review")}
            </button>
          )}
        </Container>
      </Section>
      <Modal
        onClose={() => setShowModal(false)}
        show={showModal}
        mobileBottom
        title={t("Sorry, we are unable to retrieve your bottle right now")}
      >
        <div className="warning-box Rad mb32" style={style}>
          {t(
            "Our bottle scanner has just launched, so is still in BETA mode. Please be patient while we are working to perfect our software.",
          )}
        </div>
        <label>
          {t("Search for your bottle by entering its name below instead")}:
        </label>
        <SearchHolder
          setClosedSearch={setClosedSearch}
          closed={closedSearch}
          {...props}
        />
        {/*
        <div className="hidden">
          <label>
            {t("View similar products based on data from the bottle scan")}
          </label>
          <div className={cx(s.productList, "flex row Scroll modalScroll")}>
            <Link
              href="/products/absolut-vodka"
              target="_blank"
              className={cx(
                s.productItem,
                "rowItem rowItemScroll__S text-center"
              )}
            >
              <Image
                width={240}
                height={240}
                src="/img/products/absolutVodka.jpg"
                objectFit="contain"
              />
              <p>{t("Absolut Flavoured Silicon Sitrus Vodka")}</p>
            </Link>
          </div>
        </div>
        */}
        <br />
        <div>
          <label>{t("Explore spirit categories")}</label>
          <div className={cx(s.categoryList, "flex row Scroll modalScroll")}>
            <Link
              href="/cocktails?spirits=vodka"
              target="_blank"
              className={cx(s.categoryItem, "rowItem text-center")}
            >
              {t("Vodka")}
            </Link>
            <Link
              href="/cocktails?spirits=gin"
              target="_blank"
              className={cx(s.categoryItem, "rowItem text-center")}
            >
              {t("Gin")}
            </Link>
            <Link
              href="/cocktails?spirits=rum"
              target="_blank"
              className={cx(s.categoryItem, "rowItem text-center")}
            >
              {t("Rum")}
            </Link>
            <Link
              href="/cocktails?spirits=tequila"
              target="_blank"
              className={cx(s.categoryItem, "rowItem text-center")}
            >
              {t("Tequila")}
            </Link>
            <Link
              href="/cocktails?spirits=whiskey"
              target="_blank"
              className={cx(s.categoryItem, "rowItem text-center")}
            >
              {t("Whiskey")}
            </Link>
            <Link
              href="/cocktails?spirits=liqueur"
              target="_blank"
              className={cx(s.categoryItem, "rowItem text-center")}
            >
              {t("Liqueur")}
            </Link>
            <Link
              href="/cocktails?spirits=aquavit"
              target="_blank"
              className={cx(s.categoryItem, "rowItem text-center")}
            >
              {t("Aquavit")}
            </Link>
            <Link
              href="/cocktails?spirits=bitter"
              target="_blank"
              className={cx(s.categoryItem, "rowItem text-center")}
            >
              {t("Bitter")}
            </Link>
          </div>
        </div>
        <br />
        <br />
      </Modal>
      <CreateListModal
        onClose={() => setShowCreateListModal(false)}
        show={showCreateListModal}
      />
      <CreateReviewModal
        item={product}
        type="product"
        title={product.name}
        onClose={() => setShowCreateReviewModal(false)}
        show={showCreateReviewModal}
      />
    </>
  );
};

export async function getStaticProps({ params, locale }) {
  const query = gql`
    query Product @cached(ttl: 300) {
        products(where: {slug: {_eq: "${params.slug}"}}, limit: 1) {
            id
            name
            extra_data
            description
            images(order_by: {order: asc}) {
                id
            }
            alcohol_percentage
            brand {
                name
                slug
            }
            country {
                name
                code
                slug
            }
            slug
            reviews {
                user {
                    display_name
                    first_name
                    last_name
                }
                score
                comment
                hide_name
            }
            reviews_aggregate {
              aggregate {
                avg {
                  score
                }
              }
            }
            cocktails {
                id
            }
            parent {
                name
            cocktails {
                id
            }
                parent {
                    name
            cocktails {
                id
            }
                    parent {
                        name
            cocktails {
                id
            }
                        parent {
                            name
            cocktails {
                id
            }
                        }
                    }
                }
            }
        }
    }`;
  const data = await fetcher(query);
  const product = data.products.length > 0 ? data.products[0] : null;
  /*
  let promotedCocktails =
    ((product || {}).extra_data || {}).relatedCocktails || [];
  if (promotedCocktails.length > 0) {
    const promotedQuery = `query productRelated @cached(ttl: 300) {
            cocktails(where: {id: {_in: [${promotedCocktails.join(",")}]}}) {
                ${cocktailFragment}
            }}`;
    const response = await fetcher(promotedQuery);
    promotedCocktails = (response.cocktails || []).map(cocktailTransformer);
  }
  */
  return {
    revalidate: 60,
    props: {
      slug: params.slug,
      product: product,
      ...(await serverSideTranslations(locale)),
    },
  };
}

Product.getLayout = (page) => {
  return <HomeLayout className={cx("Scanner", s.Scanner)}>{page}</HomeLayout>;
};

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}
export default Product;
